const IV_LENGTH = 12;

function toBase64(bytes) {
  const bin = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
  return btoa(bin);
}

function fromBase64(value) {
  const bin = atob(value);
  return Uint8Array.from(bin, (char) => char.charCodeAt(0));
}

async function deriveKey(secret) {
  const encoded = new TextEncoder().encode(secret);
  const hash = await crypto.subtle.digest('SHA-256', encoded);
  return crypto.subtle.importKey('raw', hash, { name: 'AES-GCM' }, false, ['encrypt', 'decrypt']);
}

export async function encryptPayload(payload, secret) {
  if (!secret) {
    throw new Error('암호화 키가 설정되지 않았습니다.');
  }

  const key = await deriveKey(secret);
  const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH));
  const encoded = new TextEncoder().encode(JSON.stringify(payload));
  const cipher = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, encoded);

  return {
    v: 1,
    iv: toBase64(iv),
    data: toBase64(new Uint8Array(cipher)),
  };
}

export async function decryptPayload(encrypted, secret) {
  if (!secret) {
    throw new Error('복호화 키를 입력해 주세요.');
  }
  if (!encrypted?.iv || !encrypted?.data) {
    throw new Error('암호화된 데이터 형식이 올바르지 않습니다.');
  }

  const key = await deriveKey(secret);
  const iv = fromBase64(encrypted.iv);
  const cipher = fromBase64(encrypted.data);
  const plain = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, cipher);

  return JSON.parse(new TextDecoder().decode(plain));
}

export function parseEncryptedPayload(raw) {
  if (typeof raw === 'string') {
    return JSON.parse(raw);
  }
  return raw;
}
